import {
  Box,
  Button,
  LoadingOverlay,
  Rating,
  Stack,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect } from "react";
import { Group } from "@mantine/core";
import { modifyUserReview } from "../../../api/apiUserReview";
import { on } from "events";
import { useDisclosure } from "@mantine/hooks";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";

const EditView = ({ data, onClose }: any) => {
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const form = useForm({
    initialValues: {
      itemTitle: data?.itemName || "",
      rate: data?.rate || 0,
      title: data?.title || "",
      content: data?.content || "",
      isUserAdmin: data?.isUserAdmin ? 1 : 0,
      isFeatured: data?.isFeatured ? 1 : 0,
    },
  });
  useEffect(() => {
    if (data) {
      form.setValues({
        itemTitle: data.itemName || "",
        rate: data.rate || 0,
        title: data.title || "",
        content: data.content || "",
        isUserAdmin: data.isUserAdmin ? 1 : 0,
        isFeatured: data.isFeatured ? 1 : 0,
      });
    }
  }, [data]);

  const handleSubmit = async (values: any) => {
    open();
    const dataModify = {
      ...data,
      // isUserAdmin: 0,
      // isFeatured: 0,
      ...values,
    };
    await modifyUserReview(dataModify, onClose);
    close();
  };
  return (
    <Box w={500} h={500} mx="auto">
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Box mb={20}>
          <TextInput
            label="Tên sản phẩm"
            placeholder="Nhập tên sản phẩm"
            {...form.getInputProps("itemTitle")}
            readOnly
            disabled
          />

          <TextInput
            label="Tiêu đề"
            placeholder="Nhập tiêu đề"
            {...form.getInputProps("title")}
          />

          <Textarea
            styles={{
              input: {
                height: "250px",
              },
            }}
            label="Nội dung"
            placeholder="Nhập nội dung đánh giá"
            {...form.getInputProps("content")}
          />
          <Group mt="md" justify="space-evenly" align="center" gap="xl">
            <Group align="center" gap="xs" style={{ cursor: "not-allowed" }}>
              <label>Đánh giá :</label>
              <Rating
                readOnly
                value={form.values.rate}
                onChange={(value) => form.setFieldValue("rate", value)}
                style={{ pointerEvents: "none" }}
              />
            </Group>
            <Box>
              <Button type="submit">Cập nhật</Button>
              <ButtonClose />
            </Box>
          </Group>
        </Box>
      </form>
    </Box>
  );
};

export default EditView;
